import React from "react";
import {ILogEntry} from "../../models/LogEntry";
import {
	Timeline,
	TimelineConnector,
	TimelineContent,
	TimelineDot,
	TimelineItem,
	TimelineOppositeContent,
	timelineOppositeContentClasses,
	TimelineSeparator,
} from "@mui/lab";
import moment from "moment";

interface ILogEntriesProps {
	logEntries: ILogEntry[];
}

const colourCodeStatus = (value: string) => {
	switch (value) {
		case "INFORMATION":
			return "#096b36";
		case "WARNING":
			return "#7c7100";
		case "ERROR":
			return "#c30000";
	}
	return "inherit";
};

export const LogEntryModal: React.FC<ILogEntriesProps> = (props) => {
	return (
		<Timeline
			sx={{
				[`& .${timelineOppositeContentClasses.root}`]: {
					flex: 0.15,
				},
			}}
		>
			{props.logEntries &&
				props.logEntries.map((log, index) => {
					return (
						<TimelineItem key={`logentry-${log.id}`}>
							<TimelineOppositeContent color="textSecondary">
								{moment(log.timeStamp).format("yyyy-MM-DD HH:mm:ss")}
							</TimelineOppositeContent>
							<TimelineSeparator>
								<TimelineDot />
								{index !== props.logEntries.length - 1 && <TimelineConnector />}
							</TimelineSeparator>
							<TimelineContent>
								<span style={{ color: colourCodeStatus(log.logLevel) }}>
									{log.logLevel}
								</span>
								<div className="content" dangerouslySetInnerHTML={{__html: log.message}}></div>
							</TimelineContent>
						</TimelineItem>
					);
				})}
		</Timeline>
	);
};
